import {Address} from '../address/address.model';

export class OperatingUnit {
  name: string;
  phone: string;
  mail: string;
  address: Address = new Address();
}
